import React, { useState } from 'react';
import GasExcelSearchBar from './excelSearchBar/GasExcelSearchBar';
import GasExcelPreview from './excelPreview/GasExcelPreview';

const GasExcel = () => {
  const [searchMap, setSearchMap] = useState({
    moduleIdx: 0,
    beginDate: new Date(),
    endDate: new Date(),
  });
  return (
    <section>
      <GasExcelSearchBar searchMap={searchMap} setSearchMap={setSearchMap} />
      <GasExcelPreview searchMap={searchMap} />
    </section>
  );
};

export default GasExcel;
